<script>
    let { data } = $props();
    const { speaker } = $derived(data);
</script>

<svelte:head>
    <title>{speaker.name} | XYMOGEN XPERIENCE 2026</title>
    <meta name="description" content={speaker.bio}>
</svelte:head>

<section class="page-container content-container-lg section-block-margin speaker-page-back">
    <a href="/speakers/" class="btn-2xl btn-link btn-link-primary">
        <i class="fa-sharp fa-solid fa-arrow-left btn__icon"></i>
        Back to Speakers
    </a>
</section>
<section class="speaker-page page-container content-container-lg section-block-margin mt-0">
    <img class="speaker-page__img" src={speaker.bioImgUrl} alt="">
    <div class="speaker-page__content">
        {#if speaker.header}
            <p class="speaker-header">
                {speaker.header}
            </p>
        {/if}
        <h1 class="heading-1 text-gray-900 text-italic">
            {speaker.name}
        </h1>
        <div class="speaker-details-info">
            <div class="topic-icon">
                <i class="fa-sharp fa-solid fa-keynote"></i> Presentation topic:
            </div>
            <h2>{@html speaker.topic}</h2>
        </div>

<!--        <div class="speaker-page__datetime-container">-->
<!--            <div>-->
<!--                <p class="speaker-page__datetime">{@html speaker.datetime}</p>-->
<!--                <p class="speaker-page__type">{@html speaker.type}</p>-->
<!--            </div>-->
<!--            <a href="/agenda" class="btn btn-sm btn-primary agenda-button">See Full Agenda</a>-->
<!--        </div>-->

        {#if speaker.aboutthetopic && speaker.aboutthetopic.length}
            <div class="speaker-page__about-the-topic">
                <p class="speaker-page__content-subtitle">About the topic:</p>
                <div class="speaker-page__about-the-topic-text">
                    {#each speaker.aboutthetopic as topic}
                        {@html topic}
                    {/each}
                </div>
            </div>
        {/if}


        {#if speaker.learningobjectives && speaker.learningobjectives.length}
            <div class="speaker-page__learning-objectives">
                <p class="speaker-page__content-subtitle">Learning objectives:</p>
                <div class="speaker-page__learning-objectives-text">
                    {#each speaker.learningobjectives as objective}
                        {@html objective}
                    {/each}
                </div>
            </div>
        {/if}

        {#if speaker.aboutthespeaker && speaker.aboutthespeaker.length}
            <div class="speaker-page__aboutthespeaker">
                <p class="speaker-page__content-subtitle">About the speaker:</p>
                <div class="speaker-page__aboutthespeaker-text">
                    {#each speaker.aboutthespeaker as objective}
                        {@html objective}
                    {/each}
                </div>
            </div>
        {/if}

        {#if speaker.socials.length}
            <ul class="speaker-page__socials">
                {#each speaker.socials as social}
                    <li>
                        <a href={social.url} title={social.platform} target="_blank">
                            <i class={`fa-brands fa-${social.platform}`}></i>
                        </a>
                    </li>
                {/each}
            </ul>
        {/if}
    </div>
</section>
<!--<section class="page-container content-container-lg section-bottom-margin">-->
<!--    <div class="hero__content hero__content&#45;&#45;speakers-page">-->
<!--        <div class="hero__content-top">-->
<!--            <h1 class="sr-only">XYMOGEN XPERIENCE</h1>-->
<!--            <div class="speakers-bottom-logos">-->
<!--                <img class="xymogen-new-logo" src="/media/x-new-logo.svg" alt="XYMOGEN" />-->
<!--                <img class="hero__logo" src="/media/XX-logo-type.svg" alt="XYMOGEN XPERIENCE" />-->
<!--            </div>-->
<!--            <img class="hero__heading" src="/media/hero-heading.svg" alt="Fitter. Smarter. Stronger. Longer." />-->
<!--            <div class="hero-block block-1"></div>-->
<!--        </div>-->
<!--        <div class="hero__content-btm">-->
<!--            <h2 class="hero__date heading-2 font-text text-600 text-gray-900">October 16 - 18, 2026</h2>-->
<!--            <a class="hero__cta btn btn-2xl btn-primary" href="/#tickets">Buy Tickets</a>-->
<!--        </div>-->
<!--    </div>-->
<!--</section>-->


<section class="sponsor-2027 single-speaker-sponsor-2027">
    <div class="sponsor-2027-logos">
        <img src="/media/xy-xx logos.svg" alt="Xymogen logo">
    </div>
    <div class="block-1"></div>
    <p>Interested in becoming a sponsor for our 2027 XPERIENCE?</p>
    <a href="/sponsorships" class="btn btn-xl btn-primary">Contact Us</a>
</section>
